import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetCasesByMachineId(machineId, page = 1, pageSize = 1000) {
  const url = `cases?page=${page}&size=${pageSize}&machine_id__in=${machineId}`;

  const { loading, error, response, refetch } = useFetchGet(url);

  return {
    loading,
    error,
    cases: response?.results,
    count: response?.count,
    refetchCases: refetch
  };
}
